import UnifiedNotification from './UnifiedNotification';

export default UnifiedNotification;
